import { Link } from "react-router-dom";

interface MarketingNavProps {
  /** Which page is currently open, so its nav link can be marked. */
  current: "home" | "teams";
}

export function MarketingNav({ current }: MarketingNavProps) {
  return (
    <nav className="mk-nav">
      <div className="shell nav-in">
        <Link to="/" className="logo" data-testid="link-marketing-home">
          Brain<i>Wrk</i>
        </Link>
        <div className="nav-links">
          <a href="#how" data-testid="nav-how">How it works</a>
          {current === "home" ? (
            <Link to="/teams" data-testid="nav-teams">For Teams</Link>
          ) : (
            <Link to="/" data-testid="nav-individuals">For Individuals</Link>
          )}
          <a href="#faq" data-testid="nav-faq">FAQ</a>
          <Link to="/login" data-testid="nav-signin">Sign in</Link>
          <a className="btn pri sm" href="#join" data-testid="nav-join-waitlist">
            Join the waitlist
          </a>
        </div>
      </div>
    </nav>
  );
}

export function MarketingFooter({ tagline }: { tagline: string }) {
  return (
    <footer className="mk-footer">
      <div className="shell foot">
        <div><strong>BrainWrk</strong> · {tagline}</div>
        <div>
          <Link to="/privacy" data-testid="footer-privacy">Privacy</Link>
          {" · "}
          <Link to="/terms" data-testid="footer-terms">Terms</Link>
          {" · "}
          <a href="mailto:hello@brainwrk.ai" data-testid="footer-contact">Contact</a>
        </div>
        <div>© {new Date().getFullYear()} BrainWrk.ai</div>
      </div>
    </footer>
  );
}

export interface FaqEntry {
  q: string;
  a: string;
}

export function MarketingFaq({ entries }: { entries: FaqEntry[] }) {
  return (
    <div className="shell faq-zone reveal" id="faq">
      <div className="kick amb">Questions</div>
      <h2>The honest FAQ</h2>
      <div className="faq">
        {entries.map((entry, index) => (
          <details key={entry.q} open={index === 0}>
            <summary>{entry.q}</summary>
            <div className="a">{entry.a}</div>
          </details>
        ))}
      </div>
    </div>
  );
}
